import React, { useCallback, useEffect, useState } from 'react';
import { getBIDashboard } from '../Services/BusinessIntelligenceService';
import { BIDashboardResponse } from '../Types/BIDashboardType';
import BIDashboardComponent from '../Components/BIDashboardComponent';

function BIDashboardPage() {
  const [data, setData] = useState<BIDashboardResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchDashboard = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getBIDashboard();
      if (response.success && response.data) {
        setData(response.data);
      }
    } catch (err) {
      console.error('Failed to load BI dashboard', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return (
    <BIDashboardComponent
      data={data}
      loading={loading}
      onRefresh={fetchDashboard}
    />
  );
}

export default BIDashboardPage;